import { Injectable } from '@angular/core';
import { TokenStorageService } from './token-storage.service';
import { v4 as uuidv4 } from 'uuid';
import { CartItem, CartItemFrontend } from '../models/cart-item';
import { AuthenticationService } from './auth.service';
import { AuthUser } from '../models/auth.models';
import { CinetykApiService } from './cinetyk-api.service';
import { Prodotto, ProdottoGet } from '../models/prodotto';
import { configurato } from '../models/configurato';
import Utility from '../helpers/utility';
import { MediaObject } from '../models/media-object';
import { GlobalComponent } from '../../global-component';
import { Indirizzo } from '../models/indirizzo';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  public carrelloTemp : CartItemFrontend[] = [];
  public idIndirizzo: number = 0;
  constructor(private tokenService: TokenStorageService, private authService: AuthenticationService, private cinetykApiService: CinetykApiService) { }

  addToCartOffline(productId: number, quantity: number, variazioni?:configurato){    
      let g = this.tokenService.getCartGuid();
      if(g==undefined || g.length == 0){
        const guid = uuidv4();
        this.tokenService.saveCartGuid(guid);
        g= guid;
      }

      let prodottoPresente: boolean = false;
      if(variazioni == null){
        this.carrelloTemp.forEach(element => {
          if(element.prodotto.find(x=> x=="/prodottos/"+productId)!= undefined){
            element.quantita += quantity;
            prodottoPresente = true;
            this.tokenService.saveCart(this.carrelloTemp);
          }
        });
      }

  
      if(!prodottoPresente){
        this.cinetykApiService.getProdottoById(productId).subscribe((d:ProdottoGet)=>{
          let cartItemFrontend: CartItemFrontend = {
            sessionId : g??'',
            prodotto : ["/prodottos/"+productId],
            quantita : quantity,
            prodottoCompleto: d
          }

          if(variazioni){
            cartItemFrontend.prodottoCompleto.prezzo = variazioni.prezzo;
            cartItemFrontend.varianti = JSON.stringify(variazioni);
            cartItemFrontend.variazioni = variazioni;
            cartItemFrontend.variazioni.idConfigurazione =uuidv4(); 
          }
          this.carrelloTemp.push(cartItemFrontend);
          this.tokenService.saveCart(this.carrelloTemp);
        })

      }
      
  }

  getImmaginePrincipale(p: ProdottoGet){
    if(p.immagini.length >0){
      return GlobalComponent.BASE_PATH_IMAGE +  p.immagini.find(x=>x.principale)!.immagine.filePath;
    }else{
      return 'assets/img/prodotti/noimage.jpg';
    }
    }

  getCarrelloOffline(){
    return this.carrelloTemp;
  }

  checkCarrelloPresente(){
    if(this.tokenService.getCart()){
      this.carrelloTemp = this.tokenService.getCart();
    }
  }
  
  setQuantity(productId: number, quantity: number){
    this.carrelloTemp.forEach(element=>{
      if(element.prodottoCompleto.id == productId){
        element.quantita = quantity;
        this.tokenService.saveCart(this.carrelloTemp);
        //AGGIORNARE IL CARRELLO ONLINE
      }
    });
    
  }


  addToCart(productId: number, quantity: number){
    let g = this.tokenService.getCartGuid();
    if(g==undefined || g.length == 0){
      const guid = uuidv4();
      this.tokenService.saveCartGuid(guid);
      g= guid;
    }
    
		let cartItem: CartItem = {
			sessionId : g??'',
			prodotto : ["/prodottos/"+productId],
			quantita : quantity,
		}

    if(this.authService.currentUser())
    {
      let u: AuthUser = this.authService.currentUser();
      cartItem.user = '/users/' + u.id;
    }
    return this.cinetykApiService.postCarrello(cartItem);
  }


  rimuoviProdotto(id:number, variazioni:configurato){
    if(variazioni!= null){
      this.carrelloTemp = this.carrelloTemp.filter(x=>x.prodottoCompleto.id != id || (x.prodottoCompleto.id == id && x.variazioni!.idConfigurazione != variazioni.idConfigurazione));
    }else{
      this.carrelloTemp = this.carrelloTemp.filter(x=>x.prodottoCompleto.id != id);
    }
    this.tokenService.saveCart(this.carrelloTemp);
  }
  
  aggiornaQuantita(id:number, quantita:number){
    this.carrelloTemp.forEach(element => {
      if(element.id == id){
        element.quantita = quantita;
        this.tokenService.saveCart(this.carrelloTemp);
      }
    });
    
  }

  getWeightCart(){
    //Calcolo il peso del carrello
    let peso:number = 0;
    this.carrelloTemp.forEach(element =>{
      peso += element.prodottoCompleto.peso * element.quantita;
    });
    return peso;
  }
  getShipmentPrice(){
    let weight = this.getWeightCart();
    let price : number = 0;
    switch(true){
      case (weight == 0):
        price = 0;
        break;
      case (weight > 0 && weight <= 1000):
        price = 5.5;
        break;
      case (weight >1000 && weight <= 3100):
        price = 6;
        break;
      case (weight >3100 && weight <= 5100):
        price = 6.5;
        break;
      case (weight >5100 && weight <= 10100):
        price = 9;
        break;    
      case (weight >10100 && weight <= 20100):
        price = 11.5;
        break;   
      case (weight >20100 && weight <= 30100):
        price = 14;
        break;   
      case (weight >30100 && weight <= 50100):
        price = 18;
        break;       
      case (weight >50100 && weight <= 70100):
        price = 26;
        break;      
      case (weight >70100 && weight <= 100000):
        price = 33.5;
        break;                                                 
    }

    return price;
  }

  getSubTotale(){
		let tot = 0;
		this.carrelloTemp.forEach(element => {
			tot += element.quantita * element.prodottoCompleto.prezzo;
		});
		return tot;
	}

  getTotale(){
    let sub = this.getSubTotale();
    let ship = this.getShipmentPrice();
    return sub + ship;
  }

  setIdAddress(id: number){
    this.tokenService.saveIdAddress(id);
  }

  getIdAddress(id: number){
    this.tokenService.getIdAddress(id);
  }

  checkAddressAvailable(indirizzo: Indirizzo)
  {
    if(indirizzo.stato!= 'Italia')
      {
        return false;
      }
      else
      {
        return true;
      }
  }
}


